import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type ImageErrorPayload = {
  path: string,
  error: string,
}

type ImageError = {
  path: string,
  message: string,
}

export interface ImageErrorsState {
  isOpen: boolean,
  errors: ImageError[],
}

const initialState: ImageErrorsState = {
  isOpen: false,
  errors: [],
}

const addError = (error: string, errors: ImageError[]): ImageError | null => {
  if (error) {
    try {
      const parsed: ImageErrorPayload = JSON.parse(error);

      // avoid duplicate error messages.
      const result = errors.filter(e => e.path === parsed.path && e.message === parsed.error);
      if (result.length === 0) {
        return { path: parsed.path, message: parsed.error };
      }
    } catch (err) { } // eslint-disable-line no-empty
  }

  return null;
}

export const librarySlice = createSlice({
  name: 'imageErrors',
  initialState,
  reducers: {
    showDialog: (state) => {
      if (state.errors.length > 0) {
        state.isOpen = true;
      }
    },
    hideDialog: (state) => {
      state.isOpen = false;
    },
    addImageError: (state, action: PayloadAction<string>) => {
      const error = addError(action.payload, state.errors);
      if (error) {
        state.errors.push(error);
      }
    },
    addImageErrors: (state, action: PayloadAction<string[]>) => {
      action.payload.forEach(item => {
        const error = addError(item, state.errors);
        if (error) {
          state.errors.push(error);
        }
      });
    },
    removeImageError: (state, action: PayloadAction<ImageError>) => {
      const idx = state.errors.findIndex(error => 
        error.message === action.payload.message && error.path === action.payload.path);

      if (idx >= 0) {
        state.errors.splice(idx, 1);
      }

      if (state.errors.length === 0) {
        state.isOpen = false;
      }
    },
    clearImageErrors: (state) => {
      state.errors = [];
      state.isOpen = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addImageError, addImageErrors, clearImageErrors, removeImageError, showDialog, hideDialog } = librarySlice.actions;

export default librarySlice.reducer;
